import {useCallback, useEffect, useState} from "react";
import * as GeoLocationApi from "src/core/api/geolocation";
import EventBus from "src/core/common/eventBus";

function useBillingAddressSearch() {
  const [state, setState] = useState({loading: false, data: undefined, error: undefined});
  useEffect(() => {
    return billingAddressEventBus.subscribe(({event, data, error}) => {
      if (event === "addresses-request-successful") {
        setState({loading: false, data, error: null});
      } else if (event === "addresses-request-failure") {
        setState({loading: false, data: null, error: error});
      }
    });
  }, []);
  const search = useCallback(
    (searchText) => {
      setState({...state, loading: true});
      return GeoLocationApi.searchAddress(searchText, {})
        .then((addressObjs) => {
          const addresses = addressObjs.map((address) =>
            GeoLocationApi.parseAddress(address)
          );
          billingAddressEventBus.notify({
            event: "addresses-request-successful",
            data: addresses,
          });
        })
        .catch((e) => {
          billingAddressEventBus.notify({event: "addresses-request-failure", error: e});
        });
    },
    [setState, state]
  );
  return [state, search];
}
const billingAddressEventBus = new EventBus();

export default useBillingAddressSearch;
